
import {
  PackInfo,
  IFilterChannelOrLibInfo,
  IPriceOption
} from "../types";
import {
  RootState
} from "../../../stores/store";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface getStartedState {
  isShowSubscribeModal: boolean;
  packInfo: PackInfo;
  isShowFitlerPopUp: boolean;
  filterChannelOrLibInfo: IFilterChannelOrLibInfo;
  filterPlansInfo: any[];
  hideOtherPacks: boolean;
  packDetailInfoId: string;
  isShowPackInfoDetail: boolean;
  isTvBoxPage: boolean;
  isBoxPlan: boolean;
}

const initialState = {
  isShowSubscribeModal: false,
  packInfo: {
    optionsContext: '',
    PriceOptions: [] as Array<IPriceOption>,
    name: ''
  },
  isShowFitlerPopUp: false,
  filterChannelOrLibInfo: {
    filterChannelOrLibId: '',
    filterChanenlOrLibImg: '',
    type: ''
  },
  hideOtherPacks: false,
  packDetailInfoId: '',
  isShowPackInfoDetail: false,
  isTvBoxPage: false,
  isNowEStatus: false,
  isBoxPlan: false,
  tncShow: false,
  tncText: '',
  videoShow: false,
  videoUrl: '',
  swiperAutoPlay: true,
}

export const GetStartedSlice = createSlice({
  name: 'getStarted',
  initialState,
  reducers: {
    setIsTvBoxPage(state, action: PayloadAction<boolean>) {
      state.isTvBoxPage = action.payload
    },
    setIsBoxPlan(state, action: PayloadAction<boolean>) {
      state.isBoxPlan = action.payload
    },
    setSubscribeModalStatus: (state, action: PayloadAction<boolean>) => {
      state.isShowSubscribeModal = action.payload
    },
    setPackInfo: (state, action: PayloadAction<PackInfo>) => {
      state.packInfo = action.payload
    },
    setisShowFitlerPopUp: (state, action: PayloadAction<boolean>) => {
      state.isShowFitlerPopUp = action.payload
    },
    setFilterPlansInfo: (state, action: PayloadAction<IFilterChannelOrLibInfo>) => {
      state.filterChannelOrLibInfo = action.payload
    },
    setHideOtherPacks: (state, action: PayloadAction<boolean>) => {
      state.hideOtherPacks = action.payload
    },
    setPackInfoDetailStatus(state, action: PayloadAction<boolean>) {
      state.isShowPackInfoDetail = action.payload
    },
    setDetailInfoId: (state, action: PayloadAction<any>) => {
      state.packDetailInfoId = action.payload
    },
    setNowEStatus(state, action: PayloadAction<boolean>) {
      state.isNowEStatus = action.payload
    },
    setTncShow(state, action: PayloadAction<boolean>){
      state.tncShow = action.payload
    },
    setTncText(state, action: PayloadAction<any>){
      state.tncText = action.payload
    },
    setVideoShow(state, action: PayloadAction<boolean>){
      state.videoShow = action.payload
    },
    setVideoUrl(state, action: PayloadAction<any>){
      state.videoUrl = action.payload
    },
    setSwiperAutoPlay(state, action: PayloadAction<boolean>){
      state.swiperAutoPlay = action.payload
    },
  }
})

export const {
  setIsTvBoxPage,
  setSubscribeModalStatus,
  setPackInfo,
  setisShowFitlerPopUp,
  setFilterPlansInfo,
  setHideOtherPacks,
  setDetailInfoId,
  setPackInfoDetailStatus,
  setNowEStatus,
  setIsBoxPlan,
  setTncShow,
  setTncText,
  setVideoShow,
  setVideoUrl,
  setSwiperAutoPlay
} = GetStartedSlice.actions

export const selectIsShowSubscribeModal = (state: RootState) => state.getStarted.isShowSubscribeModal

export default GetStartedSlice.reducer